/** @format */
import {
  setProjectIdeas,
  setProjectMainData,
  setProjectSurveys,
} from "senf-shared";
import {
  setProjectIdeaMaps,
  setProjectMaps,
  setProjectRegistrations,
} from "senf-shared/dataFetches/projectFetches";
import { SET_PROJECT } from "../types";

export const setProject = (projectId, navigate) => async (dispatch) => {
  try {
    const projectMainData = await setProjectMainData(projectId);
    if (!projectMainData) {
      navigate("/");
      dispatch({ type: SET_PROJECT, payload: null });
      return;
    }

    const [
      surveys,
      maps,
      // likes,
      // comments,
      // surveyEntries,
      // campaigns,
    ] = await Promise.all([
      setProjectSurveys(projectMainData.organizationId, projectId, false),
      setProjectMaps(projectMainData.organizationId, projectId),
      // setProjectLikes(projectId),
      // setProjectComments(projectId),
      // setProjectSurveyEntries(projectId),
      // setProjectCampaigns(projectMainData),
    ]);

    const registrations = await setProjectRegistrations(
      projectMainData,
      surveys
    );

    const ideaMaps = await setProjectIdeaMaps(
      projectMainData,
      registrations,
      maps,
      true
    );

    const project = {
      ...projectMainData,
      surveys: surveys || [],
      maps: maps || [],
      ideaMaps: ideaMaps || [],
      // likes: likes || [],
      // comments: comments || [],
      registrations: registrations || [],
      // surveyEntries: surveyEntries || [],
      // umamiData: [],
      // umamiStats: [],
      // campaigns: campaigns || [],
    };

    dispatch({ type: SET_PROJECT, payload: project });
  } catch (error) {
    console.log(error);
  }
};
